import {
  ImageRoot,
  StyledImageFallback,
  StyledImageImg,
  StyledImageLoader,
} from "./Image";
import { imageAnatomy } from "./anatomy";

export const Image = {
  Root: ImageRoot,
  Img: StyledImageImg,
  anatomy: imageAnatomy,
  Loader: StyledImageLoader,
  Fallback: StyledImageFallback,
};
